import cn from 'classnames';
import React from 'react';

import styles from './IconLoader.module.scss';

const IconLoader = (props) => {
    const {className} = props;

    return (
        <div className={cn(styles.Loader, className)}>
            <div />
            <div />
            <div />
            <div />
        </div>
    );
};

export default IconLoader;
